export default __webpack_public_path__ + "static/media/12.708d2b84.webp";